import React, { useEffect } from "react"
import ReactJson from "react-json-view"

const JsonObject = ({ jsonData, onUpdate }) => {
  useEffect(() => {
    const updateEditIcons = () => {
      const variableRows = document.querySelectorAll(
        ".react-json-view .variable-row"
      )

      variableRows.forEach((row) => {
        const objectKey = row.querySelector(".object-key span:nth-child(2)")
        const clickToEditDiv = row.querySelector(".click-to-edit")

        const dateValue = row?.querySelector(".date-value")
        if (dateValue) {
          dateValue.style.display = "none"
        }

        const editCheck = row?.querySelector(".edit-check.detected")
        if (editCheck) {
          editCheck.style.display = "none"

          const parentDiv = editCheck.parentElement // Get the parent div
          if (parentDiv) {
            parentDiv.remove() // Remove the parent div from the DOM
          }
        }

        if (objectKey && clickToEditDiv) {
          const keyText = objectKey.textContent.trim()
          if (keyText === "data") {
            clickToEditDiv.style.display = "inline-block" // Always visible for 'data'
          } else {
            clickToEditDiv.style.display = "none" // Hidden for other fields
          }

          // Add hover event listeners for non-'data' fields
          row.addEventListener("mouseenter", () => {
            if (keyText !== "data") {
              clickToEditDiv.style.display = "none"
            }
          })

          row.addEventListener("mouseleave", () => {
            if (keyText !== "data") {
              clickToEditDiv.style.display = "none" // Hide for non-'data' fields
            } else {
              clickToEditDiv.style.display = "inline-block" // Keep visible for 'data'
            }
          })
        }
      })
    }

    // Initial update
    updateEditIcons()

    // Observe DOM changes
    const observer = new MutationObserver(() => updateEditIcons())
    const container = document.querySelector(".react-json-view")
    if (container) {
      observer.observe(container, { childList: true, subtree: true })
    }

    // Cleanup
    return () => {
      if (observer) observer.disconnect()
    }
  }, [])

  return (
    <div className="json-object-container">
      {/* <JsonObjectAdd /> */}
      <ReactJson
        src={jsonData}
        onEdit={(edit) => onUpdate(edit.updated_src)}
        onAdd={false}
        onDelete={false}
        enableClipboard={false}
        displayDataTypes={false}
        name={false}
        // theme="monokai"
      />
    </div>
  )
}

export default JsonObject
